export default "__VITE_ASSET__Bx2uXCue__"